export default "__VITE_ASSET__CzSYgtr7__"